import { useWindowWidth } from "../../utils/helpers";
import textWeight from "../../utils/textWeight";
export default () => {
  const { TextWeight } = textWeight();
  const width = useWindowWidth();
  return { TextWeight, width };
};
